export const AtlassianCommunityLogoInverse = () => (
  <svg
    width="532"
    height="48"
    viewBox="0 0 532 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_815_1852)">
      <path
        d="M10.3 20.2001C9.8 19.6001 9 19.7001 8.6 20.4001L0.0999985 37.4001C-0.200001 38.0001 0.299999 38.8001 0.999999 38.8001H12.8C13.2 38.8001 13.5 38.6001 13.7 38.2001C16.3 33.0001 14.7 25.0001 10.3 20.2001Z"
        fill="url(#paint0_linear_815_1852)"
      />
      <path
        d="M16.5 4.8002C11.8 12.3002 12.1 20.6002 15.2 26.9002C18.3 33.2002 20.7 37.9002 20.9 38.3002C21.1 38.7002 21.4 38.9002 21.8 38.9002H33.6C34.4 38.9002 34.8 38.1002 34.5 37.4002C34.5 37.4002 18.6 5.6002 18.2 4.8002C17.9 4.0002 16.9 4.0002 16.5 4.8002Z"
        fill="white"
      />
      <path
        d="M155 18.4001C155 22.6001 156.9 25.9001 164.6 27.4001C169.1 28.4001 170.1 29.1001 170.1 30.6001C170.1 32.1001 169.1 33.0001 165.9 33.0001C162.2 33.0001 157.8 31.7001 154.9 30.0001V36.8001C157.2 37.9001 160.2 39.2001 165.9 39.2001C173.9 39.2001 177 35.6001 177 30.4001M177 30.4001C177 25.4001 174.4 23.1001 166.9 21.5001C162.8 20.6001 161.8 19.7001 161.8 18.4001C161.8 16.8001 163.3 16.1001 166 16.1001C169.3 16.1001 172.5 17.1001 175.6 18.5001V12.0001C173.4 10.9001 170.1 10.1001 166.2 10.1001C158.8 10.1001 155 13.3001 155 18.5001"
        fill="white"
      />
      <path
        d="M257.4 10.3003V38.8003H263.5V17.1003L266 22.9003L274.6 38.8003H282.2V10.3003H276.2V28.7003L273.9 23.4003L267 10.3003H257.4Z"
        fill="white"
      />
      <path d="M218.8 10.3003H212.2V38.8003H218.8V10.3003Z" fill="white" />
      <path
        d="M204.6 30.4001C204.6 25.4001 202 23.1001 194.5 21.5001C190.4 20.6001 189.4 19.7001 189.4 18.4001C189.4 16.8001 190.9 16.1001 193.6 16.1001C196.9 16.1001 200.1 17.1001 203.2 18.5001V12.0001C201 10.9001 197.7 10.1001 193.8 10.1001C186.4 10.1001 182.6 13.3001 182.6 18.5001C182.6 22.7001 184.5 26.0001 192.2 27.5001C196.7 28.5001 197.7 29.2001 197.7 30.7001C197.7 32.2001 196.7 33.1001 193.5 33.1001C189.8 33.1001 185.4 31.8001 182.5 30.1001V36.9001C184.8 38.0001 187.8 39.3001 193.5 39.3001C201.4 39.2001 204.6 35.7001 204.6 30.4001Z"
        fill="white"
      />
      <path
        d="M103.6 10.3003V38.8003H117.2L119.3 32.7003H110.2V10.3003H103.6Z"
        fill="white"
      />
      <path
        d="M76.7 10.3003V16.5003H84V38.8003H90.7V16.5003H98.6V10.3003H76.7Z"
        fill="white"
      />
      <path
        d="M67 10.3003H58.3L48.4 38.8003H56L57.4 34.0003C59.1 34.5003 60.9 34.8003 62.7 34.8003C64.5 34.8003 66.3 34.5003 68 34.0003L69.4 38.8003H77C76.9 38.8003 67 10.3003 67 10.3003ZM62.6 28.9003C61.3 28.9003 60.1 28.7003 59 28.4003L62.6 16.0003L66.2 28.4003C65.1 28.7003 63.9 28.9003 62.6 28.9003Z"
        fill="white"
      />
      <path
        d="M140.7 10.3003H132L122 38.8003H129.6L131 34.0003C132.7 34.5003 134.5 34.8003 136.3 34.8003C138.1 34.8003 139.9 34.5003 141.6 34.0003L143 38.8003H150.6L140.7 10.3003ZM136.3 28.9003C135 28.9003 133.8 28.7003 132.7 28.4003L136.3 16.0003L139.9 28.4003C138.8 28.7003 137.6 28.9003 136.3 28.9003Z"
        fill="white"
      />
      <path
        d="M242.7 10.3003H234L224.1 38.8003H231.7L233.1 34.0003C234.8 34.5003 236.6 34.8003 238.4 34.8003C240.2 34.8003 242 34.5003 243.7 34.0003L245.1 38.8003H252.7L242.7 10.3003ZM238.4 28.9003C237.1 28.9003 235.9 28.7003 234.8 28.4003L238.4 16.0003L242 28.4003C240.9 28.7003 239.6 28.9003 238.4 28.9003Z"
        fill="white"
      />
      <path
        d="M321.4 37.4002C319.5 38.7002 316.5 39.2002 313.3 39.2002C303.3 39.2002 297.6 33.2002 297.6 23.5002C297.6 14.2002 303.3 7.7002 313.2 7.7002C316.2 7.7002 319.2 8.3002 321.3 9.8002V13.8002C319.1 12.4002 316.7 11.7002 313.2 11.7002C306 11.7002 301.8 16.4002 301.8 23.5002C301.8 30.5002 306.2 35.2002 313.5 35.2002C316.7 35.2002 319.2 34.5002 321.5 33.3002V37.4002H321.4Z"
        fill="white"
      />
      <path
        d="M324.3 27.1001C324.3 20.1001 328.4 15.1001 335.4 15.1001C342.3 15.1001 346.4 20.2001 346.4 27.1001C346.4 34.0001 342.4 39.2001 335.4 39.2001C328.4 39.3001 324.3 34.1001 324.3 27.1001ZM328.2 27.1001C328.2 31.5001 330.4 35.5001 335.4 35.5001C340.3 35.5001 342.5 31.5001 342.5 27.1001C342.5 22.7001 340.4 18.8001 335.4 18.8001C330.4 18.8001 328.2 22.7001 328.2 27.1001Z"
        fill="white"
      />
      <path
        d="M370.8 38.8H366.8V24.8C366.8 20.6 365.1 18.8 361.3 18.8C357.6 18.8 355 21.3 355 26V38.9H351V15.5H355V19.3C356.5 16.6 359.2 15 362.4 15C366.4 15 369.1 17 370.2 20.7C371.5 17.1 374.6 15 378.5 15C383.7 15 386.6 18.5 386.6 25.1V38.7H382.6V25.9C382.6 21.1 380.9 18.7 377.1 18.7C373.4 18.7 370.8 21.2 370.8 25.9V38.8Z"
        fill="white"
      />
      <path
        d="M411.9 38.8H407.9V24.8C407.9 20.6 406.2 18.8 402.4 18.8C398.7 18.8 396.1 21.3 396.1 26V38.9H392.1V15.5H396.1V19.3C397.6 16.6 400.3 15 403.5 15C407.5 15 410.2 17 411.3 20.7C412.6 17.1 415.7 15 419.6 15C424.8 15 427.7 18.5 427.7 25.1V38.7H423.7V25.9C423.7 21.1 422 18.7 418.2 18.7C414.5 18.7 411.9 21.2 411.9 25.9V38.8Z"
        fill="white"
      />
      <path
        d="M432.8 15.5H436.8V29.5C436.8 33.7 438.5 35.5 442.3 35.5C446 35.5 448.6 33 448.6 28.3V15.5H452.6V38.8H448.6V35C447.1 37.7 444.4 39.3 441.2 39.3C435.8 39.3 432.8 35.6 432.8 29.2V15.5Z"
        fill="white"
      />
      <path
        d="M478.4 38.8H474.4V24.8C474.4 20.6 472.7 18.8 468.9 18.8C465.2 18.8 462.6 21.3 462.6 26V38.9H458.6V15.5H462.6V19.3C464.1 16.6 466.8 15 470 15C475.4 15 478.4 18.7 478.4 25.1V38.8Z"
        fill="white"
      />
      <path
        d="M486 6.6001C487.6 6.6001 488.8 7.6001 488.8 9.4001C488.8 11.2001 487.6 12.2001 486 12.2001C484.4 12.2001 483.2 11.2001 483.2 9.4001C483.2 7.6001 484.4 6.6001 486 6.6001ZM484 15.5001H488V38.8001H484V15.5001Z"
        fill="white"
      />
      <path
        d="M503.3 35.0002C504.2 35.0002 505.1 34.8002 505.8 34.7002V38.6002C505.1 38.8002 504.3 39.0002 503.1 39.0002C498.1 39.0002 495.7 36.1002 495.7 31.7002V19.3002H491.9V15.6002H495.7V10.7002H499.6V15.6002H505.8V19.3002H499.6V31.6002C499.6 33.6002 500.8 35.0002 503.3 35.0002Z"
        fill="white"
      />
      <path
        d="M516.2 37.3L507.8 15.5H512.1L519.5 35.4L526.9 15.5H531.2L522.4 38C519.8 44.7 518.3 48.1 512.4 48.1C510.4 48.1 509.3 47.9 508.1 47.4V44C509.4 44.4 511 44.6 512.1 44.6C515.4 44.6 516.8 42.4 518.7 37.3H516.2Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_815_1852"
        x1="14.9161"
        y1="22.8055"
        x2="5.9611"
        y2="38.3155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="0.923" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_815_1852">
        <rect width="532" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
